<template>
    <b-card :no-body="true">
        <div slot="header">
          <b-row>

            <b-col class="col-12 col-md-6  d-flex align-items-center">
              <div>
                <strong >
               اطلاعات معرف اول ({{ reference.full_name }})
                </strong>
          
              </div>
            </b-col>
            <b-col class="col-12 col-md-6">
              <div class="float-right">
                <!-- header-filter -->
              


                <b-button  @click="isCollapsed = !isCollapsed"
                  :class="isCollapsed ? 'btn-success ml-2' : 'btn-lightgray ml-2'">
                  <i :class="isCollapsed ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
                </b-button>


              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay :show="isOverlay" rounded="sm" :opacity="0.2">
          <!-- <template v-slot:overlay>
            <div position-absolute>
              <i class="fa fa-clock-od fa-6x" style="font-size:48px"></i>
            </div>
          </template> -->

          <b-collapse id="collapseSearchTable" :visible="isCollapsed" class="my-2">
         
                 
                 
                <b-row class="m-0">
                  <b-col cols="12"  class="py-1" >{{$lang.name }} {{$lang.family}} : {{ reference.full_name }}
                    </b-col>
                     
                      
                      <b-col v-if="reference.national_code" cols="12"  class="py-1">{{$lang.national_code }} : {{ reference.national_code }}</b-col>
                      <b-col v-if="reference.mobile" cols="12"  class="py-1">{{$lang.mobile }} : {{ reference.mobile }}</b-col>
                      <!-- <b-col v-if="reference.gender" cols="12"  class="py-1">{{$lang.gender }} :  {{ reference.gender && reference.gender.caption }}
                      </b-col> -->
                      
                      <b-col cols="12"  class="py-1"> 
                        {{$lang.city_address}}: {{ reference.last_address && reference.last_address.location  &&  reference.last_address.location.full_path}}</b-col>
                      
                      <b-col cols="12"  class="py-1"> 
                        {{$lang.regional_municipality}}:  {{ reference.last_address && reference.last_address.zone_number}}
                        </b-col>
                         <b-col cols="12"  class="py-1"> 
                         <hr>
                       </b-col>
                         <b-col cols="12"  class="py-1">{{$lang.location_relation }} : {{ locations.place_name}} </b-col>
                        <b-col cols="12"  class="py-1">
                          {{$lang.generalCollapsPerson.full_path}} : {{locations.full_path}}
                        </b-col>
                        <b-col cols="12"  class="py-1">
                          {{$lang.address_fields.address}} :  {{locations.address}}
                        </b-col>
                </b-row>
                   
                

                

             
           
          </b-collapse>
        </b-overlay>
      
      </b-card>
</template>

<script>
export default {
  props:{
    reference:{
      type:Object,
      default:{}
    },
    locations:{
      type:Object,
      default:{}
    },
  },
  data() {
    return {
      isCollapsed:false,
      isOverlay:false
    }
  },
}
</script>

<style>

</style>